import { useCallback, useEffect, useState } from "react";
import OccasionCollectionService from "../services/OccasionCollectionService";
import { OccasionCollection } from "../models";

export default function useOccasionCollections() {
  const [occasionCollections, setOccasionCollections] = useState<OccasionCollection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const api = new OccasionCollectionService();
      const data = await api.getOccasionCollections();
      setOccasionCollections(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load occasion collections");
      console.error("Error loading occasion collections:", err);
      setOccasionCollections([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    occasionCollections,
    loading,
    error,
    refetch: load,
  };
}
